import { App, Button, Modal, Popover } from "antd";
import { useState } from "react";
import AttributeForm from "$attribute/AttributeForm";
import { getNumberOfAttributes, usePostCustomer } from "$attribute/queries";
import { retrieveTokens } from "$api/tokenManagement";
import Loading from "$components/Loading";
import { useQuery } from "@tanstack/react-query";

const AddAttributeModal = () => {
  const { notification } = App.useApp();
  const [showModal, setShowModal] = useState(false);
  const { municipal } = retrieveTokens();
  const [parameters, setParameters] = useState({
    relevant: false,
    fuzziness: false,
    name: "",
    phrase: "",
    municipal_utility: municipal,
  });

  const { data: numOfAttributes, isPending } = useQuery(
    getNumberOfAttributes(municipal)
  );
  const postCustomer = usePostCustomer();

  const handleOk = () => {
    if (parameters.name !== "")
      postCustomer.mutate(parameters, {
        onSuccess: () => {
          notification.success({
            message: "Attribute wurde erfolgreich angelegt!",
          });
          setShowModal(false);
        },
        onError: (error) => {
          console.error(error);
          notification.error({
            message: "Etwas ist schief gelaufen! Versuchen Sie es erneut!",
          });
          setShowModal(false);
        },
      });
    else {
      notification.error({ message: "Name cannot be empty" });
    }
  };

  const handleCancel = () => {
    setShowModal(false);
  };

  if (isPending) {
    return <Loading />;
  }

  if (numOfAttributes >= 10) {
    return (
      <Popover
        placement="bottom"
        title="Maximale Anzahl erreicht"
        content="Die maximale Anzahl an Attribute wurde erreicht."
      >
        <Button disabled={true}>Merkmal anlegen</Button>
      </Popover>
    );
  }

  return (
    <>
      <Popover
        placement="bottom"
        title="Maximale Anzahl"
        content="Die maximale Anzahl an Attribute ist auf 10 begrenzt."
      >
        <Button onClick={() => setShowModal(true)}>Merkmal anlegen</Button>
      </Popover>
      <Modal
        title="Merkmal"
        open={showModal}
        onCancel={handleCancel}
        onOk={handleOk}
        okText="Hinzufügen"
        cancelText="Abbrechen"
      >
        {postCustomer.isPending ? (
          <Loading />
        ) : (
          <AttributeForm
            parameters={parameters}
            setParameters={setParameters}
            disabled={false}
          />
        )}
      </Modal>
    </>
  );
};

export default AddAttributeModal;
